/**
 * 등급명 → 카드/배경에 사용할 단일 색상 매핑.
 * 셀렉터에서 선택된 카드, 상태 카드 배경 등 등급별 강조 색이 필요한 모든 곳에서 공유한다.
 */
const TIER_BACKGROUND_COLOR_MAP: Record<string, string> = {
  펫루키: '#1BB898',
  펫테랑: '#21A4AB',
  펫피언: '#3685FA',
  펫스타: '#1D3BC8',
}

/** 매핑에 없는 등급명이면 기존 기본 블루(`blue700`) 폴백 */
const DEFAULT_TIER_BACKGROUND_COLOR = '#0041CC'

export const getTierBackgroundColor = (tierName: string): string => {
  return TIER_BACKGROUND_COLOR_MAP[tierName] ?? DEFAULT_TIER_BACKGROUND_COLOR
}

export interface TierButtonColors {
  background: string
  border: string
  text: string
}

/**
 * 등급명 → 등급 카드 위에 올라가는 알약 형태 버튼의 색 triple.
 * 배경은 동일 색조의 매우 옅은 톤, 테두리/글자색은 등급 브랜드 색을 그대로 사용해 시각적으로 결속.
 */
const TIER_BUTTON_COLORS_MAP: Record<string, TierButtonColors> = {
  펫루키: { background: '#E8F8F4', border: '#1BB898', text: '#1BB898' },
  펫테랑: { background: '#E9F5F6', border: '#21A4AB', text: '#21A4AB' },
  펫피언: { background: '#EBF3FE', border: '#3685FA', text: '#3685FA' },
  펫스타: { background: '#E8EBF9', border: '#1D3BC8', text: '#1D3BC8' },
}

const DEFAULT_TIER_BUTTON_COLORS: TierButtonColors = {
  background: '#EBEFFE',
  border: DEFAULT_TIER_BACKGROUND_COLOR,
  text: DEFAULT_TIER_BACKGROUND_COLOR,
}

export const getTierButtonColors = (tierName: string): TierButtonColors => {
  return TIER_BUTTON_COLORS_MAP[tierName] ?? DEFAULT_TIER_BUTTON_COLORS
}
